import React from 'react';
export function QuickWinSection() {
  return <section className="py-10 bg-main" data-id="element-202">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-203">
        <div className="text-center mb-10" data-id="element-204">
          <h2 className="text-3xl md:text-4xl font-serif text-title mb-4" data-id="element-205">
            Tu primera semana (sin agobio)
          </h2>
          <p className="text-lg text-body" data-id="element-206">
            No necesitas hacerlo perfecto. Necesitas hacerlo en orden.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 md:gap-6" data-id="element-207">
          <div className="bg-card p-6 border-t-4 border-accent shadow-sm" data-id="element-208">
            <span className="text-xs font-bold tracking-widest text-accent uppercase mb-2 block" data-id="element-209">
              Día 1
            </span>
            <h3 className="font-serif text-lg text-title mb-1" data-id="element-210">
              Ángulo + estética
            </h3>
            <p className="text-xs text-body" data-id="element-211">(para no publicar "porque sí")</p>
          </div>

          <div className="bg-card p-6 border-t-4 border-accent shadow-sm" data-id="element-212">
            <span className="text-xs font-bold tracking-widest text-accent uppercase mb-2 block" data-id="element-213">
              Día 2
            </span>
            <h3 className="font-serif text-lg text-title mb-1" data-id="element-214">
              Perfil + bio + estructura
            </h3>
            <p className="text-xs text-body" data-id="element-215">
              (para que te entiendan al instante)
            </p>
          </div>

          <div className="bg-card p-6 border-t-4 border-accent shadow-sm" data-id="element-216">
            <span className="text-xs font-bold tracking-widest text-accent uppercase mb-2 block" data-id="element-217">
              Día 3
            </span>
            <h3 className="font-serif text-lg text-title mb-1" data-id="element-218">
              10 ideas faceless listas
            </h3>
            <p className="text-xs text-body" data-id="element-219">(para no quedarte en blanco)</p>
          </div>

          <div className="bg-card p-6 border-t-4 border-accent shadow-sm" data-id="element-220">
            <span className="text-xs font-bold tracking-widest text-accent uppercase mb-2 block" data-id="element-221">
              Día 4-7
            </span>
            <h3 className="font-serif text-lg text-title mb-1" data-id="element-222">
              Publicar + ajustar sin exposición
            </h3>
            <p className="text-xs text-body" data-id="element-223">(sin volverte esclava de redes)</p>
          </div>
        </div>

        <div className="mt-10 text-center space-y-2" data-id="element-224">
          <p className="inline-block px-6 py-3 bg-alt text-title font-medium tracking-wide border border-[#D9D0C1]" data-id="element-225">
            Menos improvisación. Más claridad.
          </p>
          <p className="text-body text-sm" data-id="element-226">
            Mujeres reales. Sin exposición. Con método. Privacidad primero, pero
            con dirección.
          </p>
        </div>
      </div>
    </section>;
}